export default "__VITE_PUBLIC_ASSET__8c2f0d87__"